import { render, staticRenderFns } from "./PartsSpecType.vue?vue&type=template&id=a284d964"
import script from "./PartsSpecType.vue?vue&type=script&lang=js"
export * from "./PartsSpecType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports